import type { BrandConfig } from './types'

/**
 * Default brand configuration values
 *
 * omnyqra: product name and support address Omnyqra instead of Sim (Omnyqra/sim#41), see FORK.md
 * omnyqra: Omnyqra brand colors (Omnyqra/sim#14), see FORK.md. The stylesheet values live in
 * `app/_styles/omnyqra.css`; these feed the manifest and the emails.
 */
export const defaultBrandConfig: BrandConfig = {
  name: 'Omnyqra',
  logoUrl: undefined,
  wordmarkUrl: undefined,
  faviconUrl: undefined,
  customCssUrl: undefined,
  supportEmail: 'help@omnyqra.ai',
  documentationUrl: undefined,
  termsUrl: undefined,
  privacyUrl: undefined,
  theme: {
    primaryColor: '#6655cc',
    primaryHoverColor: '#5546b5',
    accentColor: '#6655cc',
    accentHoverColor: '#5546b5',
    backgroundColor: '#f8f8fc',
  },
  isWhitelabeled: false,
}
